
import { RowAction } from "@/components/tables/ReusableTablePage";
import { UserProfile, AccessRequest } from "@/types";
import { Pencil } from "lucide-react";

export const getUserRowActions = (
  onEdit: (user: UserProfile | AccessRequest, isRequest: boolean) => void
): RowAction[] => {
  return [
    {
      label: 'Edit',
      icon: Pencil,
      onClick: (user: UserProfile | AccessRequest) => {
        const isRequest = 'status' in user;
        onEdit(user, isRequest);
      },
    }
  ];
};
